import { coreInitiativesCommentsGetAsyncSlice } from './get';
import { CoreInitiativesCommentsName } from './name';
import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { PatchInitiativeCommentRequest } from '@api';

export const coreInitiativesCommentsUpdateSyncSlice = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: CoreInitiativesCommentsName,
	state: coreInitiativesCommentsGetAsyncSlice.asyncState,
	target: (update: PatchInitiativeCommentRequest) => (comment) => comment.id === update.id,
	update: (update: PatchInitiativeCommentRequest) => (comment) => ({
		...comment,
		...update
	})
});
